module.exports = __webpack_public_path__ + "img/huawuIcon2.643e8e10.png";